import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as alertsActions from '../Actions/alertsActions';
import Alerter from "../Components/Alert/Alerter";
import { alertService } from "../Services/AlertService.js";

class AlertListConteiner extends Component {
	constructor(props){
		super(props);
	}
	
	componentDidMount() {
//		if(this.props.isLoggedIn){
			alertService.listAlerts()
					.then(response => {return this.props.actions.fetchAlertRecords(response.data);})
					.catch(err => {/*console.log(err);*/});
//		}
	}
	
	render(){
		if(this.props.user.role=="ADMIN"){
			return (<Alerter alertCount={this.props.alertRecordsCount}/>);
		}else{
			return "";
		}
	}
}

function mapStateToProps(state, ownProps) {
//	console.log("state.alerts: "+JSON.stringify(state.alerts));
//	console.log("alertRecordsCount: "+ state.alerts.reduce(function(previousValue, currentValue, index, array) {return (array[index].active ? previousValue+1 : previousValue);}, 0));
	return {user: state.user, alertRecordsCount:  typeof state.alerts!=='undefined' ? state.alerts.reduce(function(previousValue, currentValue, index, array) {return (array[index].active ? previousValue+1 : previousValue);}, 0):0}
}

function mapDispatchToProps(dispatch) {  
	return {actions: bindActionCreators(alertsActions, dispatch)}
}

export default connect(mapStateToProps, mapDispatchToProps)(AlertListConteiner);  